/**
 * created by li si yi
 * 发布统计(本单位)
 */
export const config = {
    "name": "发布统计(本单位)",
    "key": "publishStatisticsSelf",
    "page": [
        {
            "name": "发布统计",
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "component": [
                                {
                                    "componentType": "Screen", // UI类型
                                    // type: "text", // 文本类型
                                    "placeholder": "请选择所属单位", // 空输入框提示
                                    "message": "请选择所属单位", // 校验提示
                                    "otherParams": {
                                        "showDeptSelect": false,
                                        "authorDeptId":"authorDeptId"// 本部门
                                    }
                                }
                            ]
                        }
                    ]
                ]
            },
            "renderList": {
                "listConfig": [
                    [
                        {
                            "key": "publishStatisticsSelf1",
                            "component": [
                                {
                                    "componentType": "StatisticsModule", // UI类型
                                    // type: "text", // 文本类型
                                    // "placeholder": "请选择所属单位", // 空输入框提示
                                    // "message": "请选择所属单位", // 校验提示
                                    "chartsData": {
                                        "mychartsColor": "pink",
                                        "chartsData": []
                                    }
                                }
                            ]
                        }
                    ]
                ]
            }
        }
    ],
};
